import React, { useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import "moment-timezone";
import kaPlaceholder from "../../../assets/img/fysee/ka_placeholder.png";
// import fysee25LogoWhite from "../../../assets/img/fysee/fyseefalledit-white.png";
import fysee25LogoColor from "../../../assets/img/fysee/FYSEE_26_LA_logo.png";

const EventListItem = ({ i, event_object }) => {
  const [startDate, setStartDate] = useState(null),
    [startDateNum, setStartDateNum] = useState(null),
    [startTime, setStartTime] = useState(null),
    [eventTitle, setEventTitle] = useState(""),
    [eventSlug, setEventSlug] = useState(""),
    [venueTimezone, setVenueTimezone] = useState(null),
    [venueName, setVenueName] = useState(null),
    [eventShows, setEventShows] = useState([]),
    [eventMediaSrc, setEventMediaSrc] = useState(null);

  const s3Url = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";

  useLayoutEffect(() => {
    let subscribed = true;

    if (subscribed && event_object) {
      // console.log("event object", event_object);
      Moment.globalTimezone = "America/Los_Angeles";
      Moment.globalLocale = "en-us";
      setEventTitle(event_object.title);
      setEventSlug(event_object.slug);
      setVenueName(event_object.venue_name);
      setVenueTimezone(event_object.venue_timezone);

      const tempDateTime =
        event_object.start_date.split("T")[0] + "T12:00:00.000";
      setStartDate(tempDateTime);
      setStartDateNum(event_object.start_date.split("T")[0].split("-")[2]);
      let hours =
        event_object.start_time.split(":")[0] +
        ":" +
        event_object.start_time.split(":")[1];
      let hoursFormatted = tConvert(hours);
      setStartTime(hoursFormatted);

      let uniqueShows = event_object.shows.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.title === value.title),
      );
      let sortedUniqueShows = sorter(uniqueShows);

      setEventShows(sortedUniqueShows);

      // The event's own key art wins. Without it, a single-series event uses
      // that series' textless key art. Anything else falls back to the FYSEE
      // artwork below.
      if (event_object.thumbnail) {
        setEventMediaSrc(s3Url + event_object.thumbnail);
      } else if (sortedUniqueShows.length === 1 && event_object.filename) {
        setEventMediaSrc(s3Url + event_object.filename);
      } else {
        setEventMediaSrc(null);
      }
    }
    return () => {
      subscribed = false;
    };
  }, [event_object]);

  const sorter = (array) => {
    array.sort(function (a, b) {
      var nameA = a.title.replace("The ", "").toLowerCase(),
        nameB = b.title.replace("The ", "").toLowerCase();

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
    return array;
  };

  const tConvert = (time) => {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? " AM" : " PM";
      time[0] = +time[0] % 12 || 12;
    }
    return time.join("");
  };

  return (
    <a
      key={i}
      className={"events-grid-item events-grid-item-single-title"}
      href={"/events/" + eventSlug}
    >
      <div className={"events-grid-item-header "}>
        <div className={"events-grid-item-header-mobile"}>
          <Moment format="dddd, MMM DD">{startDate}</Moment>
        </div>
        <div className={"events-grid-item-header-desktop"}>
          <div className={"events-grid-item-header-daynumber"}>
            {startDateNum}
          </div>
          <div
            className={
              "events-grid-item-header-right d-flex flex-column ms-auto"
            }
          >
            <div className={"events-grid-item-header-month"}>
              <Moment format="MMM">{startDate}</Moment>
            </div>
            <div className={"events-grid-item-header-dayname"}>
              <Moment format="dddd">{startDate}</Moment>
            </div>
          </div>
        </div>
      </div>
      <div
        className={"events-grid-item-body"}
        style={{
          background: eventMediaSrc
            ? "url(" + eventMediaSrc + "), #000"
            : "#000000",
        }}
      >
        {eventMediaSrc && <div className="events-grid-item-gradient-overlay" />}
        <img
          src={kaPlaceholder}
          alt={eventTitle}
          className={"events-grid-item-body-placeholder"}
        />

        <div className={"events-grid-item-body-absolute"}>
          {!eventMediaSrc ? (
            <div className={"events-grid-item-fyseelogo my-auto"}>
              <img
                src={fysee25LogoColor}
                alt={"FYSEELA"}
                className={"fysee25logo-small d-block mx-auto"}
                style={{ maxWidth: "80%" }}
              />
            </div>
          ) : (
            <></>
          )}

          <div className={"events-grid-item-title "}>
            <span className={""}>{eventTitle}</span>
          </div>
        </div>
      </div>
      <div className={"events-grid-item-body-shows"}>
        <div className={"events-grid-item-body-shows-copy"}>
          {eventShows &&
            eventShows.map((o, i) => {
              return (
                <span key={i} className="">
                  {i > 0 ? ", " : ""} {o.title}
                </span>
              );
            })}
        </div>
      </div>
      <div className={"events-grid-item-footer"}>
        {startTime} {venueTimezone} @ {venueName}
      </div>
    </a>
  );
};

export default EventListItem;
